import { render, staticRenderFns } from "./main-view.vue?vue&type=template&id=0f713d5b"
import script from "./main-view.vue?vue&type=script&lang=js"
export * from "./main-view.vue?vue&type=script&lang=js"
import style0 from "./main-view.vue?vue&type=style&index=0&id=0f713d5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports